
import { Component, Vue, Prop } from 'vue-property-decorator';
import IconButton from '@/components/shared/suites/IconButton.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';

@Component<PaginationControls>({
	components: {
		IconButton,
		TextButton
	}
})
export default class PaginationControls extends Vue {
	@Prop({ type: Number, required: true }) private currentPage!: number;
	@Prop({ type: Number, required: true }) private totalPages!: number;
	@Prop({ type: Number, required: false }) private totalCount!: number;
	@Prop({ type: Number, required: false }) private itemsPerPage!: number;
	@Prop({ type: Boolean, default: false }) private showIcons!: boolean;
	@Prop({ type: Boolean, default: false }) private iconOnly!: boolean;
	@Prop({ type: String, default: 'pagination' }) private idPrefix!: string;

	private get fromIndex(): number {
		return (this.currentPage - 1) * this.itemsPerPage + 1;
	}

	private get toIndex(): number {
		return Math.min(this.currentPage * this.itemsPerPage, this.totalCount);
	}

	/**
	 * Navigate to the previous page
	 *
	 * @return {void}
	 */
	private goToPreviousPage(): void {
		if (this.currentPage > 1) {
			this.$emit('previous-page');
		}
	}

	/**
	 * Navigate to the next page
	 *
	 * @return {void}
	 */
	private goToNextPage(): void {
		if (this.currentPage < this.totalPages) {
			this.$emit('next-page');
		}
	}
}
